import styled from "styled-components";
import Tag from "../Tag";
import { format, differenceInDays, startOfToday, parseISO } from "date-fns";
import Amount from "../Amount";

export const Balance = ({ account, showTitle }) => {
  const balance = account.model.getCurrentBalance();
  const daysFromBalance = differenceInDays(startOfToday(), parseISO(balance.date));

  return (
    <BalanceContainer level={4} showTitle={showTitle}>
      {showTitle && <Title level={4}>{account.model.getDisplayName()}</Title>}
      <AccountDate isCurrent={daysFromBalance <= 7}>
        {daysFromBalance <= 365 ? format(parseISO(balance.date), "dd MMM") : format(parseISO(balance.date), "MMM yy")}
      </AccountDate>
      <div style={{ alignSelf: "center", marginLeft: "-0.7em" }}>
        {balance.isAutomatic ? <span /> : <Tag severity="warning">MANUAL</Tag>}
      </div>
      <Number level={4}>
        <Amount currency={account.currency} amount={balance.balance} precision={0} showZero />
      </Number>
    </BalanceContainer>
  );
};

const BalanceContainer = styled.div`
  font-size: 0.9em;
  display: grid;
  grid-template-columns: ${(props) => (props.showTitle ? "auto auto auto 1fr" : "auto auto 1fr")};
  grid-gap: 1em;
  padding: 0.5em 1em;
`;

const AccountDate = styled.span`
  align-self: center;
  justify-self: right;
  font-weight: 600;
  color: ${(props) => (props.isCurrent ? "#999" : "#f44")};
`;

const Title = styled.span`
  color: black;
  font-variant: small-caps;
`;

const Number = styled.span`
  justify-self: right;
  align-self: center;
`;
